import { ref } from 'vue';
import axios from 'axios';
import { useStorage } from '@vueuse/core';

export default function useAlgorithmOptions() {
  const applicantsInSession = ref([]);
  const applicantsGroups = ref(['All', 'EAP & Preferred Roommates', 'Freshmen & Preferred Roommates', 'EAP', 'Freshmen',
    'Upperclassmen', 'Returning to Housing', 'Returning to Housing & Preferred Roommates', 'Not Locked, Placed, Blocked, or Tentative']);
  const algorithmWeights = useStorage('algorithmWeights', {
    sameSchoolYear: 25.0,
    preferredRommatesDigiPenEmails: 1500.0,
    preferredRoommateGenders: 700.0,
    preferRoommateClean: 5.0,
    preferRoommateSocial: 5.0,
    preferRoommateSharing: 5.0,
    preferRoommateMorningPerson: 10.0,
    preferRoommateNightPerson: 10.0,
    preferRoommateSameDegree: 2.0,
    preferredApartmentRoomRateTable1: 100.0,
    preferredApartmentRoomRateTable2: 50.0,
    preferBuyOut1: 500.0,
    preferBuyOut2: 250.0,
  });
  const buyoutRoomRates = useStorage('buyoutRoomRates', []);
  const iterationCount = useStorage('iterationCount', 10000);
  const lockedPlacedOrBlockedApplicants = ref([]);
  const lockedPlacedBlockedOrTentativeApplicants = ref([]);
  const raRoomRate = useStorage('raRoomRate', null);
  const repeatCount = useStorage('repeatCount', 10);

  const getApplicantsInSession = async (
    sessionId, onlyLockedPlacedOrBlocked = false, addTentative = false,
  ) => {
    try {
      const response = await axios.get(`${process.env.VUE_APP_HOUSING_SERVICE_URL}/api/applications/simpleApplications`, {
        params: {
          sessionId,
          onlyLockedPlacedOrBlocked,
          addTentative,
        },
      });
      const { data } = response;
      const sortedData = data?.sort((a, b) => {
        if (a.firstName > b.firstName) return 1;
        if (a.firstName < b.firstName) return -1;
        return 0;
      });
      if (onlyLockedPlacedOrBlocked && addTentative) {
        lockedPlacedBlockedOrTentativeApplicants.value = sortedData;
      } else if (onlyLockedPlacedOrBlocked) {
        lockedPlacedOrBlockedApplicants.value = sortedData;
      } else {
        applicantsInSession.value = sortedData;
      }
    } catch (error) {
      console.log(error);
    }
  };

  return {
    algorithmWeights,
    applicantsGroups,
    applicantsInSession,
    buyoutRoomRates,
    getApplicantsInSession,
    iterationCount,
    lockedPlacedOrBlockedApplicants,
    lockedPlacedBlockedOrTentativeApplicants,
    raRoomRate,
    repeatCount,
  };
}
